import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from './botoseguir.module.scss';
import Modal from './Modal';
import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import { hitAudiencies } from 'components/3catinfo/Audiencies/audiencies-datalayer';
import { useModal } from 'hooks/3catinfo/useModal';
import { useUser } from 'hooks/useUser';
import { useLaMevaLlista } from 'hooks/3catinfo/useLaMevaLlista';
import { useViewport } from 'hooks/3catinfo/useViewport';
import ModalContent from 'components/3catinfo/AreaUsuaris/ModalNoLogat';
import ModalContentAfegirContingut from 'components/3catinfo/AreaUsuaris/ModalAfegirContingut';
import ModalSnackbar from 'components/3catinfo/AreaUsuaris/ModalSnackbar';
import Icona from '../ui/Icona/Icona';
import useIsServiceEnabled from 'hooks/useIsServiceEnabled';
import __isEmpty from 'lodash/isEmpty';
import { getStorageValue, setStorageValue } from '@portal-internet/core';
import __isUndefined from 'lodash/isUndefined';

const BotoSeguir = ({
    obreEsquerra = false,
    text,
    textMissatge,
    textHitAudiencies,
    id,
    tipologia,
    linkTipus,
    slug,
    estil,
    isItemNoti = false,
    enviaApi,
    tooltipInici = false,
    originUsuaris = false
}) => {
    const isVrEnabled = useIsServiceEnabled('videos-recomanats');
    const isRmEnabled = useIsServiceEnabled('resume-media');
    const isSpmEnabled = isVrEnabled && isRmEnabled;

    const [showModal, setShowModal] = useState(false);
    const [showTooltipInici, setShowTooltipInici] = useState(false);
    const [isPrimeraNotiVista, setIsPrimeraNotiVista] = useState(false);
    const [hoverModal, setHoverModal] = useState(false);
    const [hideTooltip, setHideTooltip] = useState(false);
    const [opensEsquerra, setOpensEsquerra] = useState(obreEsquerra);
    const hoverModalRef = useRef(hoverModal);
    const timerTooltipInici = useRef(null);
    const modalRef = useRef(null);
    const buttonRef = useRef(null);
    const [isTimeoutActive, setIsTimeoutActive] = useState(false);
    const { setModal } = useModal();
    const { isMobile } = useViewport();
    const { zoomNavigator } = useViewport();
    const route = {
        type: 'web_3catinfo_meu3catinfo'
    };

    const routeBoto = {
        slug: slug,
        type: linkTipus
    };

    const nomCookie = 'cookieVisitedNews';
    const estructuraCookieDefault = {
        day: '2020/01/01'
    };
    const cookieValueRef = useRef(estructuraCookieDefault);

    const stylesOverlay = clsx({
        [styles.overlay]: !opensEsquerra,
        [styles.esquerra]: opensEsquerra && !showTooltipInici,
        [styles.forMobile]: isMobile && !showTooltipInici,
        [styles.overlayInici]: showTooltipInici,
        [styles[estil]]: !!estil
    });

    const stylesEnllac = clsx({
        [styles.enllac]: true,
        [styles.ambZoom]: zoomNavigator > 3
    });

    const { isAuthenticated } = useUser();
    const { isALaMevaLlista, toggleSelection, toggleSelectionNoApi, loaded, itemsLaMevaLlista } = useLaMevaLlista();

    const isMounted = useRef(true);

    const llistatTemes = itemsLaMevaLlista[tipologia];

    const [bookMarkActive, setBookMarkActive] = useState(false);
    const cookieContingutShowed = 'afegirContingutShowed';
    const cookieNoMostris = 'noMostrisMes';

    const saveOnStorage = (values) => {
        setStorageValue(nomCookie, values, {
            path: '/',
            domain: '.3cat.cat',
            expires: 30
        });
    };

    const initializeValues = (data) => {
        let response;
        if (__isUndefined(data)) {
            response = estructuraCookieDefault;
        } else {
            response = data;
        }
        return response;
    };

    const fetchDayCookieData = async () => {
        if (tooltipInici) {
            const data = await getStorageValue(nomCookie);
            const value = initializeValues(data);
            cookieValueRef.current = value;
            const todayDate = getToday();
            if (value.day !== todayDate) {
                value.day = todayDate;
                setIsPrimeraNotiVista(true);
            }
        }
    };

    const getToday = () => {
        const dateObj = new Date();
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        return year + '/' + month + '/' + day;
    };

    useEffect(() => {
        isMounted.current = true;
        if (tooltipInici) {
            fetchDayCookieData();
        }

        const actualizarAncho = () => {
            if (buttonRef.current && tooltipInici) {
                const ample = buttonRef.current.getBoundingClientRect().width;
                document.documentElement.style.setProperty('--ample-boto', `${ample}px`);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            actualizarAncho();
        });

        resizeObserver.observe(buttonRef.current);

        actualizarAncho();

        return () => {
            isMounted.current = false;
            if (modalRef.current) {
                clearTimeout(modalRef.current);
            }
            resizeObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!tooltipInici || !isPrimeraNotiVista) {
            return;
        }
        timerTooltipInici.current = setTimeout(() => {
            if (!bookMarkActive && __isEmpty(llistatTemes) && isPrimeraNotiVista) {
                setShowTooltipInici(true);
                saveOnStorage({ ...cookieValueRef.current, day: getToday() });
            }
        }, 1000);

        return () => {
            if (timerTooltipInici.current) {
                clearTimeout(timerTooltipInici.current);
            }
        };
    }, [isPrimeraNotiVista, loaded, bookMarkActive, llistatTemes, tooltipInici]);

    useEffect(() => {
        hoverModalRef.current = hoverModal;
    }, [hoverModal]);

    useEffect(() => {
        if (!loaded) {
            return;
        }

        setBookMarkActive(!!isALaMevaLlista(Number(id), tipologia));
    }, [loaded, id, tipologia, isALaMevaLlista]);

    const stylesBotoSeguir = clsx({
        [styles.inLineSegueix]: true,
        [styles.senseBotoSeguir]: !isSpmEnabled,
        [styles.fonsTaronja]: bookMarkActive,
        [styles.amagaFletxa]: !showTooltipInici,
        [styles[estil]]: !!estil
    });

    const showModalNoLogat = (title) => {
        setModal(<ModalContent />, { className: styles.modal, title });
    };

    const showModalAfegirContingut = async (title) => {
        const hasShownAfegirContingut = await getStorageValue('afegirContingutShowed');
        if (hasShownAfegirContingut !== true) {
            setTimeout(() => {
                setModal(<ModalContentAfegirContingut />, {
                    className: styles.modal,
                    isModalSegueix: true,
                    title_segueix: title,
                    mode: 'scroll',
                    initialY: window.scrollY,
                    text: textMissatge,
                    tipologia: tipologia,
                    style: 'slowTransition'
                });
            }, 500);
        }
    };

    const showModalSnackbar = (afegit) => {
        const title = afegit ? `Has començat a seguir ${textMissatge}` : `S'ha eliminat ${textMissatge}`;
        setModal(<ModalSnackbar />, {
            className: styles.modal,
            title,
            mode: 'scroll',
            text: textMissatge,
            tipologia: tipologia,
            afegit: afegit,
            style: 'outsideClic'
        });
    };

    const trackAudiencies = (tipologia, text) => {
        const labels = {
            NOT_AUTOR: 'Autor',
            DTY_CATEGORY: 'Tema'
        };
        const label = labels[tipologia];
        if (label) {
            const extraData = {};
            if (tipologia === 'NOT_AUTOR') {
                extraData.autor = text;
            } else if (tipologia === 'DTY_CATEGORY') {
                extraData.temes = text;
            }
            hitAudiencies('scSeguir', {
                URL: window.location.href,
                pantallaFavorits: `${label}: ${text}`,
                ...extraData
            });
        }
    };
    const toggleModalHandler = useCallback(async () => {
        if (!isAuthenticated) {
            setShowModal(false);
            setHoverModal(false);
            setHideTooltip(true);
            showModalNoLogat('Inicia sessió amb el teu compte 3Cat');
            return;
        }

        //Forçem el tooltip a l'esquerra o dreta si sobresurt del viewport
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        const pixelsFromRight = buttonRect ? window.innerWidth - buttonRect.right : 0;
        const pixelsFromLeft = buttonRect.left;
        if (pixelsFromRight < 300) {
            setOpensEsquerra(true);
        } else if (pixelsFromLeft < 300) {
            setOpensEsquerra(false);
        }

        setShowModal(false);

        setBookMarkActive((prev) => !prev);
        if (enviaApi) {
            await toggleSelection(Number(id), tipologia);
        } else {
            await toggleSelectionNoApi(Number(id), tipologia);
        }

        setIsTimeoutActive(true);
        modalRef.current = setTimeout(() => {
            if (isMounted.current) {
                if (!hoverModalRef.current) {
                    setShowModal(false);
                }
                setIsTimeoutActive(false);
            }
        }, 2000);

        if (!originUsuaris) {
            if (!bookMarkActive) {
                if ((await getStorageValue(cookieNoMostris)) !== true) {
                    // check oneday expired
                    getStorageValue(cookieContingutShowed).then((data) => {
                        const value = initializeValues(data);
                        if (new Date() - new Date(value.day) >= 24 * 60 * 60 * 1000) {
                            showModalAfegirContingut('Segueix el tema a El meu 3CatInfo');
                        } else {
                            showModalSnackbar(true);
                        }
                    });
                } else {
                    showModalSnackbar(true);
                }
            } else {
                showModalSnackbar(false);
            }
            setShowModal(false);
            setHoverModal(false);
            setHideTooltip(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, id, tipologia, showModalNoLogat, toggleSelection]);

    const handleMouseOut = () => {
        if (!isTimeoutActive || hoverModal) {
            setShowModal(false);
        }
    };
    const elmTresCatinfo = <span className={styles.bold}>El meu 3CatInfo</span>;
    const textContent = (bookMarkActive, route) => {
        let textContent;
        if (showTooltipInici) {
            textContent = (
                <>
                    Segueix totes les notícies
                    <br />
                    del tema a&nbsp;{elmTresCatinfo}
                </>
            );
        } else if (hoverModal && !bookMarkActive) {
            textContent = <>Segueix el tema</>;
        } else if (hoverModal && bookMarkActive) {
            textContent = <>Elimina d&#39;{elmTresCatinfo}</>;
        } else if (!hoverModal && bookMarkActive) {
            textContent = (isItemNoti && isMobile && <>Tema afegit a&nbsp;{elmTresCatinfo}</>) || (
                <>S&#39;ha afegit a&nbsp;{elmTresCatinfo}</>
            );
        } else {
            textContent = <>S&#39;ha eliminat d&#39;{elmTresCatinfo}</>;
        }

        return textContent;
    };

    const tancarTooltipInici = () => {
        setShowTooltipInici(false);
    };

    const textBoto = bookMarkActive ? text || 'Seguint' : text || 'Segueix';
    return (
        <div className={stylesBotoSeguir} ref={buttonRef} data-testid='boto-seguir'>
            {/* Si tenim link */}
            {routeBoto.slug && (
                <div className={styles.boto}>
                    <Enllac route={routeBoto} className={stylesEnllac} redirect={true}>
                        {textBoto}
                    </Enllac>
                    {isSpmEnabled && (
                        <button
                            data-testid='btn-seguir'
                            className={styles.botoSeguir}
                            onClick={(e) => {
                                setHoverModal(false);
                                toggleModalHandler(id, tipologia);
                                if (!bookMarkActive) trackAudiencies(tipologia, textHitAudiencies);
                                tancarTooltipInici();
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Escape') {
                                    setHoverModal(false);
                                    setShowModal(false);
                                }
                            }}
                            onMouseEnter={() => {
                                clearTimeout(modalRef.current);
                                setHoverModal(true);
                                setShowModal(true);
                            }}
                            onFocus={() => {
                                clearTimeout(modalRef.current);
                                if (hideTooltip) {
                                    setHideTooltip(false);
                                } else {
                                    setHoverModal(true);
                                    setShowModal(true);
                                }
                            }}
                            onMouseLeave={handleMouseOut}
                            onBlur={handleMouseOut}
                            aria-label={bookMarkActive ? 'Seguint' : 'Segueix'}
                        >
                            <Icona
                                icona={bookMarkActive ? 'verificat' : 'mes'}
                                isBlanc={true}
                                inline={true}
                                className={styles.iconaSeguir}
                            />
                        </button>
                    )}
                </div>
            )}
            {/* Si no tenim link i tenim el boto activat */}
            {!routeBoto.slug && isSpmEnabled && (
                <button
                    data-testid='btn-seguir'
                    className={styles.boto}
                    onClick={(event) => {
                        setHoverModal(false);
                        toggleModalHandler(id, tipologia);
                        if (!bookMarkActive) trackAudiencies(tipologia, textHitAudiencies);
                        tancarTooltipInici();
                    }}
                    aria-label={bookMarkActive ? 'Seguint' : 'Segueix'}
                    onMouseEnter={() => {
                        setHoverModal(true);
                        setShowModal(true);
                    }}
                    onFocus={() => {
                        if (hideTooltip) {
                            setHideTooltip(false);
                        } else {
                            setHoverModal(true);
                            setShowModal(true);
                        }
                    }}
                    onMouseLeave={() => {
                        setShowModal(false);
                        setHoverModal(false);
                    }}
                    onBlur={() => setShowModal(false)}
                >
                    <span className={styles.enllac}>{textBoto}</span>
                    <span className={styles.botoSeguir}>
                        <Icona
                            icona={bookMarkActive ? 'verificat' : 'mes'}
                            isBlanc={true}
                            inline={true}
                            className={styles.iconaSeguir}
                        />
                    </span>
                </button>
            )}
            <div ref={modalRef}>
                {showTooltipInici ? (
                    <Modal isOpen={showTooltipInici}>
                        <div className={stylesOverlay} data-testid='tooltip-seguir'>
                            {textContent(bookMarkActive, route)}
                            <button className={styles.tancar} onClick={tancarTooltipInici} data-testid='tooltip-close'>
                                <Icona
                                    className={styles.iconaTancar}
                                    icona='tanca'
                                    alt='tanca'
                                    mida='9'
                                    isBlanc={true}
                                    inline={true}
                                />
                            </button>
                        </div>
                    </Modal>
                ) : (
                    <Modal isOpen={showModal}>
                        {(isItemNoti || !(hoverModal && !bookMarkActive)) && enviaApi && (
                            <div className={stylesOverlay} data-testid='tooltip-hover-seguir'>
                                {textContent(bookMarkActive, route)}
                            </div>
                        )}
                    </Modal>
                )}
            </div>
        </div>
    );
};

export default React.memo(BotoSeguir);
